import { Component } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

import { Button, Result, notification } from 'antd';
import { WPLE_API } from '../api/request';

import { DownloadOutlined } from '@ant-design/icons';

import { saveAs } from 'file-saver';

class WpleDownload extends Component {
  constructor() {
    super(...arguments);

    this.state = {
      buttonLoading: false,
    };
  }

  // strToBytes = (str) => {
  //   var bytes = new Uint8Array(str.length);
  //   for (var i = 0; i < str.length; i++) {
  //     bytes[i] = str.charCodeAt(i);
  //   }
  //   return bytes;
  // };

  downloadSSLZip = () => {
    this.setState({ buttonLoading: true });

    WPLE_API('downloadsslzip', { orderid: this.props.orderid }).then((res) => {
      this.setState({ buttonLoading: false });
    });
  };

  downloadPrivateKey = () => {
    this.setState({ buttonLoading: true });

    WPLE_API('downloadprivatekey', { orderid: this.props.orderid }).then(
      (res) => {
        this.setState({ buttonLoading: false });
      }
    );
  };

  render() {
    const { buttonLoading } = this.state;

    return (
      <Result
        status="success"
        title="Hurray! Premium SSL Certificate Ready to Download"
        subTitle="Download the premium certificate zip containing SSL certificate and CA bundle files, download private key file separately and install both of them on your hosting panel (You can open these certificate files using simple notepad / text editor) OR You can also send it to your hosting support to install it for you. https:// site will start working soon after installation and you need not worry about SSL renewal upto an year / Pro license expiry."
        extra={[
          <h3>
            You'll need only 2 files in downloaded zip. Please go to{' '}
            <b>Plain Text Files</b> in zip, <b>Yourdomainname.txt</b> is the
            primary SSL certificate and{' '}
            <b>SectigoRSADomainValidationSecureServerCA.txt</b> is the CA Bundle
            file.
          </h3>,
          <Button
            type="primary"
            loading={buttonLoading}
            key="downloadcrt"
            icon={<DownloadOutlined />}
            onClick={this.downloadSSLZip}>
            Download SSL Certificate
          </Button>,
          <Button
            type="primary"
            loading={buttonLoading}
            key="downloadkey"
            icon={<DownloadOutlined />}
            onClick={this.downloadPrivateKey}>
            Download Private Key
          </Button>,
        ]}
      />
    );
  }
}

export default WpleDownload;

